import { keyToUrl } from '@tools/common'

export const packagingKeys = {
  root: (companyId?: number) => ['packagingTypes', companyId ?? null] as const,
  packagingType: (id: number) => ['packagingTypes', id] as const,
}

export const packagingUrls = {
  root: (companyId: number) =>
    keyToUrl(['companies', companyId, 'packagingTypes']),
  packagingType: (companyId: number, id: number) =>
    keyToUrl(['companies', companyId, 'packagingTypes', id]),
}
